import { render, staticRenderFns } from "./InboundIcon.vue?vue&type=template&id=f846e980&"
import script from "./InboundIcon.vue?vue&type=script&lang=ts&"
export * from "./InboundIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports